import { useState } from "react";

import { useCartItems } from "@faire/retailer/hooks/cart/useCartItems";

const useCartQuantity = (productToken: string) => {
  const { getProductTileQuantityInCart } = useCartItems();
  return { cartQuantity: getProductTileQuantityInCart(productToken) };
};

export const useIsNonZeroQuantityPickerValue = (productToken: string) => {
  const { cartQuantity } = useCartQuantity(productToken);
  const [isNonZero, setIsNonZero] = useState(cartQuantity !== 0);

  const onQuantityUpdate = (value?: number) => {
    if (value !== undefined) {
      setIsNonZero(value !== 0);
    }
  };

  return { isNonZero, onQuantityUpdate };
};
